/*
 * @overview: 事件注册
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 16:39:32
 */

import { options } from "./options";
import { injectNotice, injectReminder } from "../lib";
import { initHttp } from "../api/http";

/**
 * 初始化监听事件
 * @returns
 */
export const setUp = () => {
  if (!use()) return;
  // 初始化http配置
  initHttp(options);
  // 前端通知
  injectNotice(options.key);
  // 升级提醒
  injectReminder();
};

/**
 * 是否开启监听
 * @returns
 */
const use = () => {
  if (!options.use) {
    console.log("upgradeReminder 升级提醒已关闭");
    return false;
  }
  console.log("upgradeReminder 升级通知已开启，稳定运行中...");
  return true;
};
